import { render, staticRenderFns } from "./ZyroColorPickerPlain.vue?vue&type=template&id=1561c377&scoped=true&"
import script from "./ZyroColorPickerPlain.vue?vue&type=script&lang=js&"
export * from "./ZyroColorPickerPlain.vue?vue&type=script&lang=js&"
import style0 from "./ZyroColorPickerPlain.vue?vue&type=style&index=0&id=1561c377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561c377",
  null
  
)

export default component.exports